import { render } from "./ChartCard.vue?vue&type=template&id=36901e2a&scoped=true"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"

import "./ChartCard.vue?vue&type=style&index=0&id=36901e2a&scoped=true&lang=css"
import "./ChartCard.vue?vue&type=style&index=1&id=36901e2a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36901e2a"]])

export default __exports__